export default {
  'c++': 'cpp',
  'java': 'java',
  'c': 'c',
  'c#': 'cs',
  'javascript': 'js',
  'python': 'py',
  'ruby': 'rb',
  'swift': 'swift',
  'go': 'go'
}



// WEBPACK FOOTER //
// ./src/utils/css_class_lang_map.js